<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">我的设备借用申请</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="formInline.user_name" clearable placeholder="请输入姓名"></el-input>
        </el-form-item> -->
        <el-form-item label="设备名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入设备"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room_id" clearable filterable
            :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed prop="device_name" label="设备名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="device_no" label="编号" width="120">
        </custom-table-column>
        <custom-table-column label="审核状态" width="150" prop="status" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="oper_name" label="审核人" width="120">
        </custom-table-column>
        <custom-table-column prop="training_room_name" :label="`所属${$store.state.themeTitle}室`" min-width="180">
        </custom-table-column>
        <custom-table-column prop="num" label="借用数量" width="150">
        </custom-table-column>
        <custom-table-column prop="start_time" label="借用开始时间" width="160">
        </custom-table-column>
        <custom-table-column prop="end_time" label="借用结束时间" width="160">
        </custom-table-column>
        <custom-table-column prop="usage" label="用途" min-width="220">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.status == 'pass' && !scope.row.return_date" @click="handleReturn(scope.row.id)"
              type="text" size="small">归还</el-button> -->
            <el-button v-if="scope.row.status == 'apply'" @click="handleDelet(scope.row.id)" type="text"
              size="small">取消申请</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <!-- <el-dialog :close-on-click-modal="false" title="归还" :visible.sync="numberDialogVisible" width="406px">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
        <el-form-item label="归还日期" prop="return_date">
          <el-date-picker type="datetime" placeholder="选择归还日期" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm1.return_date" style="width:242px;"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm1', changeReturnStatus)">确认</el-button>
          <el-button @click="resetForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan, mixinFormatter],
  data() {
    return {
      formInline: {
        // user_name: '',
        training_room_id: '',
        name: '',
        // structure_1: '',
        // major: '',
        status: ''
      },
      levell: [1, 2],
      organLabel: '',
      detailDialogVisible: false,
      eqs: [],
      rowObj: [],
      Returns: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        training_room_id: '',
        order_start: '',
        order_end: '',
        reason: '',
        items: [],
      },
      numberDialogVisible: false,
      listArr: [],
      remainder_quantity: 0,
      rules: {
        training_room_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        order_start: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        order_end: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        reason: [{ required: true, message: '申请理由不能为空', trigger: 'blur' }],
      },
      ruleForm1: {
        id: '',
        return_date: '',
      },
      rules1: {
        return_date: [{ required: true, message: '请选择归还时间', trigger: 'change' }],
      },
      rules1: {},
    };
  },
  components: {},
  created() { },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
    this.$store.dispatch('getTarinMent');
  },
  methods: {
    handleReturn(id) {
      this.numberDialogVisible = true;
      this.ruleForm1.id = id;
    },
    handleDelet(id) {
      this.confirmBox('warning', `此操作将取消该借用申请，是否继续`, { id }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/device_borrow/apply/cancel/${params.id}`, 'post', { });
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '取消成功！',
        });
        this.getList();
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/device_borrow/apply/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
